import { combineReducers } from 'redux-immutable';
import { immutableExperimentReducer as abisko } from '@svt/abtest/redux-immutable';

import autocomplete from './autocomplete';
import continueWatching from './continueWatching';
import filter from './filter';
import settings from './settings';
import utils from './utils';
import videoPage from './videoPage';
import network from './network';
import videoPlayer from './videoPlayer';

export const reducer = combineReducers({
    abisko,
    autocomplete,
    continueWatching,
    filter,
    network,
    settings,
    utils,
    videoPage,
    videoPlayer,
});
